<template>
  <div class="card fade-up stop-dragging" @click="chooseCard">
    <img class="stop-dragging" :src="imgSrc">
  </div>
</template>

<script>
export default {
  name: 'Card',
  props: {
    imgSrc: {
      type: String
    }
  },
  data: () => {
    return {
    }
  },
  mounted() {
  },
  methods: {
    chooseCard() {
      this.$emit("chooseCard");
    }
  }
}
</script>

<style>
</style>
<style scoped>
.card {
  color: white;
  background-color: white;
  border-radius: 15px;
  border: 0px solid gray;
  margin: 5px;
  display: inline-block;
  box-shadow: 0px 1px 2px #80808033;
  transform: none;
  -webkit-animation-duration: 0.5s;
  animation-duration: 0.5s;
  transition-duration: 0.1s;
  flex-grow: 1;
  padding: 3px;
  margin: 10px;
  flex: 0 0 38%;
}
.card img {
  transition-duration: 0.1s;
  border-radius: 15px;
  width: 100%;
  height: 100%;
}
.card:hover {
  cursor: pointer;
  margin: 0px 10px;
}
.card:hover img {
  margin-left: -10px;
  margin-top: -10px;
  width: calc(100% + 20px);
  height: calc(100% + 20px);
}
.card .fade-up {
  animation-delay: 0.5s;
}
@media screen and (min-width: 400px) {
  .card {
    padding: 10px;
  }
}
@media screen and (min-width: 800px) {
  .card {
    flex: 0 0 25%;
  }
}
</style>
